// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_centered-col__ZSCYp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.styles_hide-scrollbar__A1px2 {
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .styles_hide-scrollbar__A1px2::-webkit-scrollbar {
    display: none; }

.styles_singleLineText__MfBkY {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.styles_width-fill-available__6uVae, .styles_overlayLoader__bCC2Q {
  width: 100%;
  /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  width: fill-available; }

.styles_height-fill-available__g8O9e, .styles_overlayLoader__bCC2Q {
  height: 100%;
  /* WebKit-based browsers will ignore this. */
  height: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  height: fill-available; }

.styles_feedTable__wGeAN {
  border-radius: 0.75rem;
  overflow: visible;
  background-color: transparent;
  padding: 0; }

.styles_feedTableHeader__f19d1 {
  background: transparent;
  border-bottom: none;
  box-shadow: none;
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 0 0.5rem;
  margin-bottom: 0.5rem; }

.styles_feedTableHeaderColumn__yCrzG {
  flex: 1 1;
  height: 3rem;
  padding: 0 1.25rem;
  border-right: none;
  transition: all 0.2s ease; }
  .styles_feedTableHeaderColumn__yCrzG:first-child {
    padding-left: calc(\$cellPadding + 0.5rem); }
  .styles_feedTableHeaderColumn__yCrzG:last-child {
    padding-right: calc(\$cellPadding + 0.5rem); }
  .styles_feedTableHeaderColumn__yCrzG .title {
    font-weight: 600;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #8080805c;
    opacity: 0.8; }

.styles_feedTableRow__6Deti {
  min-height: 3.5rem;
  border-bottom: none;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: white;
  margin-bottom: 0.75rem;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04); }
  .styles_feedTableRow__6Deti:last-child {
    margin-bottom: 0; }
  .styles_feedTableRow__6Deti.styles_clickable__Rg1qD {
    cursor: pointer; }
    .styles_feedTableRow__6Deti.styles_clickable__Rg1qD:hover {
      background-color: white;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06); }
    .styles_feedTableRow__6Deti.styles_clickable__Rg1qD:active {
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04); }
  .styles_feedTableRow__6Deti:not(.styles_clickable__Rg1qD):hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04); }

.styles_feedTableCell__PQkY3 {
  flex: 1 1;
  min-height: 3.5rem;
  padding: 1.25rem;
  border-right: none;
  transition: all 0.2s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  min-width: 0;
  position: relative; }
  .styles_feedTableCell__PQkY3:first-child {
    padding-left: calc(\$cellPadding + 0.5rem);
    border-radius: 0.75rem 0 0 0.75rem; }
  .styles_feedTableCell__PQkY3:last-child {
    padding-right: calc(\$cellPadding + 0.5rem);
    border-radius: 0 0.75rem 0.75rem 0; }
  .styles_feedTableCell__PQkY3 > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%; }
  .styles_feedTableCell__PQkY3:hover {
    overflow: visible;
    z-index: 100; }
    .styles_feedTableCell__PQkY3:hover > * {
      overflow: visible;
      white-space: normal;
      max-width: none;
      position: relative;
      z-index: 101;
      background-color: white;
      padding: 0.5rem 1rem;
      margin: -0.5rem;
      border-radius: 0.375rem;
      box-shadow: 0 4px 12px #8080801a; }
    .styles_feedTableCell__PQkY3:hover .text {
      overflow: visible;
      white-space: normal;
      word-break: break-word; }
    .styles_feedTableCell__PQkY3:hover a {
      overflow: visible;
      white-space: normal; }
  .styles_feedTableCell__PQkY3 .text {
    font-size: 0.9rem;
    color: #808080b8;
    line-height: 1.6;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .styles_feedTableCell__PQkY3 a {
    color: #2563eb;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
    .styles_feedTableCell__PQkY3 a:hover {
      color: #1d4ed8;
      text-decoration: underline; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/styles/classes.scss","webpack://./src/modules/Core/components/Feed/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,qBAAqB,EAAA;EAFvB;IAII,aAAa,EAAA;;AAIjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACY,4CAAA;EACvB,6BAA6B;EAAE,6CAAA;EAC/B,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACY,4CAAA;EACxB,8BAA8B;EAAE,6CAAA;EAChC,sBAAsB,EAAA;;ACjBxB;EACE,sBAToB;EAUpB,iBAAiB;EACjB,6BAA6B;EAC7B,UAAU,EAAA;;AAGZ;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iBAAiB;EACjB,qBAAqB,EAAA;;AAGvB;EACE,SAAS;EACT,YA9BiB;EA+BjB,kBA9BmB;EA+BnB,kBAAkB;EAClB,yBAAyB,EAAA;EAL3B;IAQI,yCAAyC,EAAA;EAR7C;IAYI,0CAA0C,EAAA;EAZ9C;IAgBI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,gBCvCc;IDwCd,YAAY,EAAA;;AAIhB;EACE,kBAvDmB;EAwDnB,mBAAmB;EACnB,kDAAkD;EAClD,uBAAuB;EACvB,sBAvDc;EAwDd,sBAzDoB;EA0DpB,wEAAwE,EAAA;EAP1E;IAUI,gBAAgB,EAAA;EAVpB;IAcI,eAAe,EAAA;IAdnB;MAiBM,uBAAuB;MACvB,2BAA2B;MAC3B,wEAAwE,EAAA;IAnB9E;MAuBM,2BAA2B;MAC3B,wEAAwE,EAAA;EAxB9E;IA6BI,wEAAwE,EAAA;;AAI5E;EACE,SAAS;EACT,kBAzFmB;EA0FnB,gBAxFmB;EAyFnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB,EAAA;EAZpB;IAeI,yCAAyC;IACzC,kCApGkB,EAAA;EAoFtB;IAoBI,0CAA0C;IAC1C,kCAA8C,EAAA;EArBlD;IA0BI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe,EAAA;EA7BnB;IAkCI,iBAAiB;IACjB,YAAY,EAAA;IAnChB;MAsCM,iBAAiB;MACjB,mBAAmB;MACnB,eAAe;MACf,kBAAkB;MAClB,YAAY;MACZ,uBAAuB;MACvB,oBAAoB;MACpB,eAAe;MACf,uBAAuB;MACvB,gCC9HY,EAAA;ID+ElB;MAmDM,iBAAiB;MACjB,mBAAmB;MACnB,sBAAsB,EAAA;IArD5B;MAyDM,iBAAiB;MACjB,mBAAmB,EAAA;EA1DzB;IA+DI,iBAAiB;IACjB,gBC1Ic;ID2Id,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EArEvB;IAyEI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;IA/EvB;MAkFM,cAAc;MACd,0BAA0B,EAAA","sourcesContent":[".centered-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.singleLineText {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.width-fill-available {\n  width: 100%;\n  width: -moz-available; /* WebKit-based browsers will ignore this. */\n  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  width: fill-available;\n}\n\n.height-fill-available {\n  height: 100%;\n  height: -moz-available; /* WebKit-based browsers will ignore this. */\n  height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  height: fill-available;\n}\n","@import \"src/modules/Core/styles/classes.scss\";\n@import \"src/modules/Core/styles/variables.scss\";\n\n$defaultRowHeight: auto;\n$minRowHeight: 3.5rem;\n$headerHeight: 3rem;\n$cellPadding: 1.25rem;\n$borderRadius: 0.75rem;\n$rowGap: 0.75rem;\n\n.overlayLoader {\n  @extend .width-fill-available;\n  @extend .height-fill-available;\n}\n\n.feedTable {\n  border-radius: $borderRadius;\n  overflow: visible;\n  background-color: transparent;\n  padding: 0;\n}\n\n.feedTableHeader {\n  background: transparent;\n  border-bottom: none;\n  box-shadow: none;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  padding: 0 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.feedTableHeaderColumn {\n  flex: 1 1;\n  height: $headerHeight;\n  padding: 0 $cellPadding;\n  border-right: none;\n  transition: all 0.2s ease;\n  \n  &:first-child {\n    padding-left: calc($cellPadding + 0.5rem);\n  }\n  \n  &:last-child {\n    padding-right: calc($cellPadding + 0.5rem);\n  }\n  \n  :global(.title) {\n    font-weight: 600;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    color: $grey36;\n    opacity: 0.8;\n  }\n}\n\n.feedTableRow {\n  min-height: $minRowHeight;\n  border-bottom: none;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  background-color: white;\n  margin-bottom: $rowGap;\n  border-radius: $borderRadius;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);\n  \n  &:last-child {\n    margin-bottom: 0;\n  }\n  \n  &.clickable {\n    cursor: pointer;\n    \n    &:hover {\n      background-color: white;\n      transform: translateY(-2px);\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);\n    }\n    \n    &:active {\n      transform: translateY(-1px);\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04);\n    }\n  }\n  \n  &:not(.clickable):hover {\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04);\n  }\n}\n\n.feedTableCell {\n  flex: 1 1;\n  min-height: $minRowHeight;\n  padding: $cellPadding;\n  border-right: none;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  min-width: 0; // Important for flex children to allow text truncation\n  position: relative;\n  \n  &:first-child {\n    padding-left: calc($cellPadding + 0.5rem);\n    border-radius: $borderRadius 0 0 $borderRadius;\n  }\n  \n  &:last-child {\n    padding-right: calc($cellPadding + 0.5rem);\n    border-radius: 0 $borderRadius $borderRadius 0;\n  }\n  \n  // Ensure text content inside respects overflow\n  > * {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n  }\n  \n  // On hover, show full text with overflow\n  &:hover {\n    overflow: visible;\n    z-index: 100;\n    \n    > * {\n      overflow: visible;\n      white-space: normal;\n      max-width: none;\n      position: relative;\n      z-index: 101;\n      background-color: white;\n      padding: 0.5rem 1rem;\n      margin: -0.5rem;\n      border-radius: 0.375rem;\n      box-shadow: 0 4px 12px $grey10;\n    }\n    \n    :global(.text) {\n      overflow: visible;\n      white-space: normal;\n      word-break: break-word;\n    }\n    \n    a {\n      overflow: visible;\n      white-space: normal;\n    }\n  }\n  \n  :global(.text) {\n    font-size: 0.9rem;\n    color: $grey72;\n    line-height: 1.6;\n    font-weight: 400;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  \n  a {\n    color: #2563eb;\n    text-decoration: none;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    \n    &:hover {\n      color: #1d4ed8;\n      text-decoration: underline;\n    }\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centered-col": `styles_centered-col__ZSCYp`,
	"hide-scrollbar": `styles_hide-scrollbar__A1px2`,
	"singleLineText": `styles_singleLineText__MfBkY`,
	"width-fill-available": `styles_width-fill-available__6uVae`,
	"overlayLoader": `styles_overlayLoader__bCC2Q`,
	"height-fill-available": `styles_height-fill-available__g8O9e`,
	"feedTable": `styles_feedTable__wGeAN`,
	"feedTableHeader": `styles_feedTableHeader__f19d1`,
	"feedTableHeaderColumn": `styles_feedTableHeaderColumn__yCrzG`,
	"feedTableRow": `styles_feedTableRow__6Deti`,
	"clickable": `styles_clickable__Rg1qD`,
	"feedTableCell": `styles_feedTableCell__PQkY3`
};
export default ___CSS_LOADER_EXPORT___;
